const selectors = {
  headerSection: '.header-section',
};

let config = {
  pixelAnchorId: 'top-of-site-pixel-anchor',
  atTopClass: 'header-at-top',
  notAtTopClass: 'header-not-at-top',
  stickyActiveClass: 'sticky-header-active',
};

/**
 * Set the --header-height CSS custom prop
 */
const setHeaderHeight = (headerHeight) => {
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
};

/**
 * Initialize the controller
 */
const init = (options) => {
  config = { ...config, ...options };

  // Create the pixel anchor element and append to the top of body
  const pixelAnchor = document.createElement('div');
  pixelAnchor.setAttribute('id', config.pixelAnchorId);
  document.body.appendChild(pixelAnchor);

  // Set up the IntersectionObserver to toggle the sticky class
  if (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype &&
    document.querySelector(`#${config.pixelAnchorId}`)
  ) {
    const headerSection = document.querySelector(selectors.headerSection);

    if (!headerSection) return;

    const observer = new IntersectionObserver((entries) => {
      if (!headerSection) return;

      setHeaderHeight(headerSection.offsetHeight);

      if (entries[0].boundingClientRect.y < 0) {
        document.body.classList.add(config.notAtTopClass);
      } else {
        document.body.classList.remove(config.notAtTopClass);
      }
    });

    document.body.classList.add(config.stickyActiveClass);

    observer.observe(document.querySelector(`#${config.pixelAnchorId}`));

    // Re-Set the header height property any time a class is toggled in the header
    headerSection.addEventListener('toggleClass', () => {
      setHeaderHeight(headerSection.offsetHeight);
    });
  }
};

/**
 * Header Controller
 */
const headerController = {
  init,
};

export default headerController;
